import { showCreateSubObjectiveModalAction, hideCreateSubObjectiveModalAction } from 'actions/createSubObjectiveModal';

export const showCreateSubObjectiveModal = () => (dispatch) => dispatch(showCreateSubObjectiveModalAction());

export const hideCreateSubObjectiveModal = () => (dispatch) => dispatch(hideCreateSubObjectiveModalAction());
